<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import FormDependenciesList from "@Alternatives/Forms/Components/FormDependenciesList.vue";
    import { FormDefDependenciesReadModel } from "@Alternatives/Forms/Domain/readmodels";
    import { FormDependenciesDialogViewModel } from "@Alternatives/Forms/Components/FormDependenciesDialog";


    @Component({
        components: { FormDependenciesList },
        props: {
            viewModel: { type: Object, required: true }
        }
    })
    export default class FormDependenciesDialog extends Vue
    {
        get vm(): FormDependenciesDialogViewModel { return this.$props.viewModel as FormDependenciesDialogViewModel; }

        get opened(): boolean { return this.vm?.opened ?? false; }
        get initialized(): boolean { return this.vm.initialized; }
        get name(): string { return this.vm.name; }
        get deps(): FormDefDependenciesReadModel | null { return this.vm.deps; }
        get dependantsCount(): number | null { return this.deps?.Count ?? null; }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Form dependencies</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h4 v-if="!initialized">
                            <i class="fa fa-spinner fa-spin"></i> Checking dependencies...
                        </h4>
                        <div v-if="initialized">
                            <div class="alert alert-warning text-dark" role="alert">
                                <p>The form '<strong>{{name}}</strong>' is used in <strong>{{dependantsCount}}</strong> places.</p>
                            </div>
                            <FormDependenciesList :readModel="deps" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>